<template>
    <div class="custom-payment-wrapper">
        <div class="page-wrapper">
            <header class="top-header">
                <div class="brand-area">
                    <div class="logo-circle">
                        <img class="soimg" src="/../images/logo/logox.png" alt="SOIRS Logo">
                    </div>
                    <div class="brand-text">
                        <h1>Sokoto State Internal Revenue Service</h1>
                        <p><i class="fa-solid fa-location-dot"></i> No. 4 Kano Road, Investment House Sokoto,</p>
                        <p>Sokoto State, Nigeria</p>
                    </div>
                </div>

                <div class="secure-box">
                    <div class="secure-icon">
                        <i class="fa-solid fa-shield-halved"></i>
                    </div>
                    <div>
                        <h3>Secure Payment</h3>
                        <p>Your payment is safe and encrypted</p>
                    </div>
                </div>
            </header>

            <div v-if="remark == 'success'" class="success-shell">
                <div class="success-card">
                    <div class="success-icon-wrap">
                        <img src="/../images/success.svg" class="success-image" alt="Success" width="100" height="44">
                    </div>
                    <h2>Payment Successful</h2>
                    <p>Your payment has been confirmed successfully.</p>

                    <button
                        type="button"
                        class="btn action-btn print-success-btn"
                        @click="handleClick(2)"
                    >
                        <span class="btn-left"><i class="fa-solid fa-print"></i></span>
                        <span>Print Invoice</span>
                        <i class="fa-solid fa-angle-right"></i>
                    </button>
                </div>
            </div>

            <main v-else class="content-grid">
                <section class="main-card">
                    <form id="registerform" @submit.prevent="" @keydown="paymentForm.errors.clear($event.target.name)">
                        <div class="section-intro">
                            <div class="intro-icon">
                                <i class="fa-regular fa-file-lines"></i>
                            </div>
                            <div>
                                <h2>Payment Request</h2>
                                <p>Please review the details below and complete your payment.</p>
                            </div>
                        </div>

                        <hr class="divider">

                        <div class="section-block">
                            <h3 class="section-title">
                                <i class="fa-regular fa-user"></i>
                                Payer Information
                            </h3>

                            <div class="info-grid">
                                <div class="info-card">
                                    <div class="info-icon">
                                        <i class="fa-regular fa-user"></i>
                                    </div>
                                    <div class="info-text">
                                        <span>Payer Name</span>
                                        <strong>{{ paymentForm.name || '-' }}</strong>
                                    </div>
                                </div>

                                <div class="info-card">
                                    <div class="info-icon">
                                        <i class="fa-regular fa-envelope"></i>
                                    </div>
                                    <div class="info-text">
                                        <span>Payer Email</span>
                                        <strong>{{ paymentForm.email || '-' }}</strong>
                                    </div>
                                </div>

                                <div class="info-card">
                                    <div class="info-icon">
                                        <i class="fa-solid fa-phone"></i>
                                    </div>
                                    <div class="info-text">
                                        <span>Payer Number</span>
                                        <strong>{{ paymentForm.phone || '-' }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="section-block">
                            <h3 class="section-title">
                                <i class="fa-regular fa-file-lines"></i>
                                Payment Details
                            </h3>

                            <div class="details-box">
                                <div class="details-item">
                                    <span>Payment MDA</span>
                                    <strong>{{ mda || '-' }}</strong>
                                </div>

                                <div class="details-divider"></div>

                                <div class="details-item">
                                    <span>Payment Description</span>
                                    <strong>{{ pay_item || description || '-' }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="amount-box">
                            <div class="amount-left">
                                <div class="amount-icon">
                                    <i class="fa-regular fa-credit-card"></i>
                                </div>
                                <span>Total Amount Payable</span>
                            </div>
                            <div class="amount-value">{{ paymentForm.amount | formatMoney }}</div>
                        </div>
                    </form>
                </section>

                <aside class="sidebar-card">
                    <div class="invoice-box">
                        <div class="invoice-icon">
                            <i class="fa-regular fa-file-lines"></i>
                        </div>
                        <div class="invoice-text">
                            <span>Invoice Number</span>
                            <h3>{{ paymentForm.invoice_no }}</h3>
                        </div>
                    </div>

                    <hr class="divider">

                    <template v-if="trx">
                        <div class="transfer-section">
                            <h3 class="section-title green">
                                <i class="fa-solid fa-building-columns"></i>
                                PAY WITH TRANSFER
                            </h3>

                            <div class="transfer-card">
                                <div class="bank-row">
                                    <span>Bank Name:</span>
                                    <strong>{{ paymentForm.bank_name ? paymentForm.bank_name.replace(/Bank$/i, '').trim() : '-' }}</strong>
                                </div>
                                <div class="bank-row">
                                    <span>Account No:</span>
                                    <strong>{{ paymentForm.account_number || '-' }}</strong>
                                </div>
                                <div class="bank-row">
                                    <span>Account Name:</span>
                                    <strong>{{ paymentForm.account_name || '-' }}</strong>
                                </div>
                                <div class="bank-row">
                                    <span>Amount:</span>
                                    <strong>{{ paymentForm.amount | formatMoney }}</strong>
                                </div>

                                <button
                                    :disabled="iHavePaidLoading"
                                    :style="{ background: 'linear-gradient(90deg, #03572c, #0b6f38)', color: '#ffffff' }"
                                    class="btn transfer-btn"
                                    type="button"
                                    @click="iHavePaid()"
                                >
                                    <template v-if="iHavePaidLoading">
                                        <i class="fa-solid fa-spinner fa-spin"></i>
                                        Checking Payment...
                                    </template>
                                    <template v-else>
                                        <i class="fa-regular fa-circle-check"></i>
                                        I Have Transferred
                                    </template>
                                </button>

                                <div class="expire-note">
                                    <template v-if="timeLeft.total > 0">
                                        <i class="fa-regular fa-clock"></i>
                                        This one-time account expires in <strong>{{ timeLeft.hours }}h {{ timeLeft.minutes }}m {{ timeLeft.seconds }}s</strong>
                                    </template>
                                    <template v-else>
                                        <i class="fa-regular fa-clock"></i>
                                        This one-time account has expired.
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="gateway-section">
                        <div class="or-pay">OR PAY ONLINE</div>
                        <div class="gateway-grid">
                            <button
                                :class="['gateway-card', { active: selectedGateway === 4, loading: paymentForm.isLoading && selectedGateway === 4 }]"
                                :disabled="paymentForm.isLoading"
                                type="button"
                                @click="handleClick(4)"
                            >
                                <div class="gateway-logo">
                                    <svg viewBox="0 0 64 64" aria-hidden="true">
                                        <rect width="64" height="64" rx="13" fill="#07334a" />
                                        <path d="M16 28c9-2 22-3 29-2 4 .6 5.3 4.1 3 7.2L26 55l10.4-22.5c.8-1.8-.3-3.3-2.3-3.2L16 28z" fill="#ef1b2d" />
                                        <circle cx="47" cy="19" r="7" fill="#ef1b2d" />
                                    </svg>
                                </div>
                                <span>{{ paymentForm.isLoading && selectedGateway === 4 ? 'Processing...' : 'Interswitch' }}</span>
                            </button>

                            <button
                                v-if="trx"
                                :class="['gateway-card', 'gateway-card-monnify', { active: selectedGateway === 3, loading: paymentForm.isMonnifyLoading }]"
                                :disabled="paymentForm.isMonnifyLoading"
                                type="button"
                                @click="handleClick(3)"
                            >
                                <div class="gateway-logo">
                                    <svg viewBox="0 0 64 64" aria-hidden="true">
                                        <circle cx="16" cy="39" r="8" fill="#f7941d" />
                                        <circle cx="48" cy="39" r="8" fill="#f6c215" />
                                        <circle cx="25" cy="24" r="8" fill="#02b3ad" />
                                        <circle cx="39" cy="24" r="8" fill="#02b3ad" />
                                        <path d="M24 28c2 8 6 13 8 13s6-5 8-13" fill="none" stroke="#02b3ad" stroke-width="12" stroke-linecap="round" />
                                    </svg>
                                </div>
                                <span>{{ paymentForm.isMonnifyLoading ? 'Processing...' : 'Monnify' }}</span>
                            </button>

                            <button
                                :class="['gateway-card', { active: selectedGateway === 1, loading: paymentForm.isLoading && selectedGateway === 1 }]"
                                :disabled="paymentForm.isLoading"
                                type="button"
                                @click="handleClick(1)"
                            >
                                <div class="gateway-logo">
                                    <svg viewBox="0 0 64 64" aria-hidden="true">
                                        <circle cx="32" cy="32" r="29" fill="#f15a24" />
                                        <text x="24" y="42" font-size="34" font-weight="700" font-family="Arial, sans-serif" fill="#fff">r</text>
                                        <circle cx="44" cy="40" r="4" fill="#00a887" />
                                    </svg>
                                </div>
                                <span>{{ paymentForm.isLoading && selectedGateway === 1 ? 'Processing...' : 'Remita' }}</span>
                            </button>
                        </div>
                    </div>

                    <button
                        :disabled="paymentForm.isPrintLoading"
                        class="btn print-btn"
                        type="button"
                        @click="handleClick(2)"
                    >
                        <i class="fa-solid fa-print"></i>
                        {{ paymentForm.isPrintLoading ? 'Preparing...' : 'Print Invoice' }}
                    </button>
                </aside>
            </main>

            <footer class="footer-note">
                <p><i class="fa-solid fa-shield-halved"></i> SOIRS is committed to protecting your data and ensuring secure transactions.</p>
                <small>© 2024 Sokoto State Internal Revenue Service. All rights reserved.</small>
            </footer>
        </div>
    </div>
</template>
  
  <script>
    export default {
        data() {
            return {
                paymentForm: new Form({
                    isLoading: false,
                    isMonnifyLoading: false,
                    isPrintLoading: false,
                    invoice_no: this.$route.params.invoice_no,
                    reference: '',
                    user_id: '',
                    tax_office_id: '',
                    name: '',
                    phone: '',
                    email: '',
                    amount: '',
                    gateway_id: '',
                    description: '',
                    invoice_date: '',
                    account_number: '',
                    account_name: '',
                    bank_name: '',
                    expires_on: '',
                    print_invoice: false,
                    pay_items: [{
                        mda_id: '',
                        pay_item_id: '',
                        amount: '',
                        description: ''
                    }]
                }),
                selectedGateway: 4,
                mda: '',
                pay_item: '',
                tax_id: '',
                rrr: '',
                trx: '',
                remark: '',
                description: '',
                checkout_url: '',
                timeLeft: {
                    total: 0,
                    minutes: 0,
                    seconds: 0
                },
                timer: null,
                iHavePaidLoading: false,
            }
        },
        mounted(){
            this.getPayment();
            this.calculateTimeLeft();
            this.timer = setInterval(this.calculateTimeLeft, 1000);
            const link = document.createElement('link');
            link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
            link.rel = 'stylesheet';
            link.id = 'bootstrap-css';
            document.head.appendChild(link);
        },
        beforeUnmount() {
            const link = document.getElementById('bootstrap-css');
            if (link) {
            document.head.removeChild(link);
            }
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        methods: {
            getPayment() {
                axios.get('/api/make-payment/' + this.$route.params.invoice_no)
                    .then(response => {
                        const data = response.data;
                        // First validate the response structure
                        if (!data || !data.payment_items || !data.payment_items.length) {
                            throw new Error('Invalid payment data received');
                        }

                        // Update form fields
                        this.paymentForm.user_id = data.user_id;
                        this.paymentForm.reference = data.reference;
                        this.paymentForm.invoice_no = data.invoice_no;
                        this.paymentForm.name = data.payer_name;
                        this.paymentForm.phone = data.payer_phone;
                        this.paymentForm.email = data.payer_email;
                        this.paymentForm.amount = data.amount;
                        this.paymentForm.pay_items = data.payment_items;
                        this.paymentForm.gateway_id = data.gateway_id;
                        this.paymentForm.tax_office_id = data.tax_office_id;
                        
                        // Safely access array elements
                        const firstPaymentItem = data.payment_items[0];
                        this.mda = firstPaymentItem?.mda?.name || '';
                        this.pay_item = firstPaymentItem?.pay_item?.name || '';
                        
                        this.remark = data.remark;
                        this.description = data.description;
                        this.paymentForm.invoice_date = data.created_at;
                        this.paymentForm.account_name = data.account_name;
                        this.paymentForm.bank_name = data.bank_name;
                        this.paymentForm.account_number = data.account_number;
                        this.paymentForm.expires_on = data.expires_on;
                        this.rrr = data.rrr;
                        this.trx = data.trx;
                        this.checkout_url = data.checkout_url;
                    })
                    .catch(error => {
                        console.error('Payment fetch error:', error);
                        
                        // Show appropriate error message
                        const errorMsg = error.response?.data?.message || 
                                    error.message || 
                                    'Failed to load payment details';
                        toastr.error(errorMsg);
                        
                        this.$router.push('/search-by-invoice-no');
                    });
            },
            storePayment() {
                const effectiveGateway = this.selectedGateway === 4 ? 1 : this.selectedGateway;

                if (effectiveGateway === 1 && !this.paymentForm.print_invoice) {
                    if (this.rrr == null) {
                        const gatewayName = this.selectedGateway === 4 ? 'Interswitch' : 'Remita';
                        toastr.warning(gatewayName + ' is not available at the moment.');
                        return;
                    }
                    this.paymentForm.isLoading = true;
                    this.paymentForm.isMonnifyLoading = false;
                } else if (effectiveGateway === 3) {
                    this.paymentForm.isMonnifyLoading = true;
                    this.paymentForm.isLoading = false;
                }

                // Optionally update the gateway_id to preserve it in the backend
                this.paymentForm.gateway_id = effectiveGateway;

                if (effectiveGateway === 1 && !this.paymentForm.print_invoice) {
                    this.paymentForm.isLoading = false;
                    this.paymentForm.isPrintLoading = false;
                    this.paymentForm.isMonnifyLoading = false;
                    this.makeRemitaPayment(this.rrr);
                } else if (effectiveGateway === 3) {
                    this.paymentForm.isMonnifyLoading = false;
                    this.paymentForm.isLoading = false;
                    this.paymentForm.isPrintLoading = false;
                    window.location.href = this.checkout_url;
                }

                // this.paymentForm.post('/api/payment')
                //     .then(response => {
                //         this.paymentForm.reference = response.reference;
                //         this.tax_id = response.user.tax_id;
                //         this.paymentForm.phone = response.user.phone;
                //         this.paymentForm.email = response.user.email;
                //         this.paymentForm.pay_items = response.payment_items;
                //         this.paymentForm.amount = response.amount;
                //         this.rrr = response.rrr;

                        
                //     })
                //     .catch(error => {
                //         if (this.selectedGateway === 1 && !this.paymentForm.print_invoice) {
                //             this.paymentForm.isLoading = false;
                //             this.paymentForm.isPrintLoading = false;
                //         } else if (this.selectedGateway === 3) {
                //             this.paymentForm.isMonnifyLoading = false;
                //         }
                //         toastr.error(error.message);
                //         helper.showErrorMsg(error);
                //     });
            },
            getConfig(config){
                return helper.getConfig(config);
            },
            makeRemitaPayment(rrr) {
                const self = this;
                var randomnumber = Math.floor(Math.random());
                var paymentEngine = RmPaymentEngine.init({
                    key: "QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY",
                    merchantName: "Sokoto Internal Revenue Services",
                    processRrr: true,
                    transactionId: randomnumber,
                    extendedData: { 
                        customFields: [ 
                            { 
                                name: "rrr", 
                                value: rrr
                            } 
                        ]
                    },
                    
                    onSuccess: function (response) {
                        axios.get('/api/payment/verify/?rrr=' + rrr)
                            .then(response => response.data)
                            .then(response => {
                                if (response.data.message == "Successful") {
                                    toastr.success('Payment successful.');
                                    //this.$router.push('/payment/' + response.data.orderId);
                                    window.location.href = '/handle-payment-callback?paymentReference=' + response.data.orderId;
                                } else {
                                    console.log(response);
                                    toastr.error('There is an error.');
                                }
                            })
                            .catch(error => {
                                helper.showDataErrorMsg(error)
                            });
                    },
                    onError: function (response) {
                        toastr.error(response);
                        console.log('callback Error Response', response);
                    },
                    onClose: function () {
                        self.getPayment();
                        toastr.error('Payment canceled by user.');
                    }
                });
                    paymentEngine.showPaymentWidget();
            },

            previewsUrl(){
                return window.history.back();
            },

            handleClick(index){
                this.selectedGateway = index;
                if (index === 2) {
                    this.paymentForm.isPrintLoading = true;
                    window.location.href = '/handle-payment-callback?paymentReference=' + this.paymentForm.reference;
                    this.paymentForm.isPrintLoading = false;
                    return;
                }

                this.storePayment();
            },
            calculateTimeLeft() {
                const expiry = moment.utc(this.paymentForm.expires_on);
                const now = moment.utc();
                const duration = moment.duration(expiry.diff(now));
                const totalSeconds = Math.max(0, Math.floor(duration.asSeconds()));

                this.timeLeft = {
                    total: totalSeconds,
                    hours: Math.floor(totalSeconds / 3600),
                    minutes: Math.floor((totalSeconds % 3600) / 60),
                    seconds: totalSeconds % 60
                };

                if (totalSeconds <= 0 && this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            iHavePaid(){
                this.iHavePaidLoading = true;
                axios.get('/api/payment/verify/?trx=' + this.paymentForm.reference)
                    .then(response => response.data)
                    .then(response => {
                        if (response.responseBody.invoiceStatus == "PAID") {
                            toastr.success('Payment successful.');
                            window.location.href = '/handle-payment-callback?paymentReference=' + response.responseBody.invoiceReference;
                        } else {
                            toastr.error('We couldn\'t find any payment.');
                        }
                        this.iHavePaidLoading = false;
                    })
                    .catch(error => {
                        this.iHavePaidLoading = true;
                        helper.showDataErrorMsg(error)
                    });
            }
        },
        filters: {
          formatMoney(value){
            return helper.formatMoney(value);
          }
        },
    }
</script>
  
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css');

.custom-payment-wrapper {
    --green-dark: #023b1f;
    --green: #0e6e3a;
    --green-2: #128248;
    --green-soft: #edf8f1;
    --green-border: #d6eadb;
    --text-dark: #1c2420;
    --text-light: #6f7a73;
    --white: #ffffff;
    --line: #e7ece8;
    --orange: #ff7b1f;
    --teal: #0996a7;
    --shadow: 0 20px 45px rgba(0, 0, 0, 0.1);
    --radius-xl: 24px;
    --radius-lg: 18px;
    --radius-md: 14px;
    font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
    background:
        radial-gradient(circle at top left, rgba(255, 255, 255, 0.04) 1px, transparent 1px),
        radial-gradient(circle at bottom right, rgba(255, 255, 255, 0.04) 1px, transparent 1px),
        linear-gradient(135deg, #014b27 0%, #01371d 100%);
    background-size: 18px 18px, 22px 22px, cover;
    min-height: 100vh;
    color: var(--text-dark);
    padding: 18px 22px 24px;
    font-weight: 400;
    position: relative;
    overflow: hidden;
}

.custom-payment-wrapper::before,
.custom-payment-wrapper::after {
    content: "";
    position: absolute;
    pointer-events: none;
    opacity: 0.22;
}

.custom-payment-wrapper::before {
    right: -120px;
    top: 120px;
    width: 520px;
    height: 520px;
    background:
        radial-gradient(circle at center, transparent 55%, rgba(255,255,255,0.22) 55.4%, transparent 56.2%),
        radial-gradient(circle at center, transparent 63%, rgba(255,255,255,0.16) 63.4%, transparent 64.1%),
        radial-gradient(circle at center, transparent 71%, rgba(255,255,255,0.12) 71.4%, transparent 72.1%);
    border-radius: 50%;
}

.custom-payment-wrapper::after {
    left: -180px;
    bottom: 40px;
    width: 460px;
    height: 460px;
    background:
        radial-gradient(circle at center, transparent 57%, rgba(255,255,255,0.14) 57.4%, transparent 58.1%),
        radial-gradient(circle at center, transparent 68%, rgba(255,255,255,0.10) 68.4%, transparent 69.1%);
    border-radius: 50%;
}

.page-wrapper {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
}

.top-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
    color: #fff;
    gap: 20px;
}

.brand-area {
    display: flex;
    align-items: center;
    gap: 18px;
}

.logo-circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);
}

.soimg {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.brand-text h1 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 6px;
    letter-spacing: -0.2px;
}

.brand-text p {
    font-size: 13px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 2px;
}

.secure-box {
    display: flex;
    gap: 12px;
    align-items: center;
    text-align: right;
    padding-top: 10px;
}

.secure-icon {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6ef08f;
    font-size: 18px;
}

.secure-box h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
}

.secure-box p {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.75);
}

.content-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.86fr) minmax(360px, 0.94fr);
    gap: 12px;
    align-items: start;
}

.main-card,
.sidebar-card,
.success-card {
    background:
        radial-gradient(circle at top left, rgba(18, 130, 72, 0.08), transparent 30%),
        radial-gradient(circle at bottom right, rgba(9, 150, 167, 0.05), transparent 24%),
        rgba(255, 255, 255, 0.97);
    border-radius: 18px;
    box-shadow: 0 18px 34px rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(230, 238, 233, 0.75);
    backdrop-filter: blur(6px);
}

.main-card {
    padding: 28px 24px 22px;
    height: 100%;
}

.sidebar-card {
    padding: 26px 20px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.section-intro {
    display: flex;
    gap: 18px;
    align-items: center;
}

.intro-icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: var(--green-soft);
    color: var(--green-2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    flex-shrink: 0;
}

.section-intro h2 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 6px;
    letter-spacing: -0.2px;
}

.section-intro p {
    color: var(--text-light);
    font-size: 14px;
    font-weight: 400;
}

.divider {
    border: none;
    height: 1px;
    background: var(--line);
    margin: 20px 0;
}

.section-block {
    margin-bottom: 24px;
}

.section-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-dark);
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
}

.section-title i {
    color: var(--green-2);
}

.section-title.green {
    color: var(--green);
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
}

.info-card {
    border: 1px solid var(--green-border);
    background: linear-gradient(180deg, rgba(255,255,255,0.92), rgba(243,250,246,0.92));
    border-radius: var(--radius-md);
    padding: 18px 18px;
    display: flex;
    align-items: center;
    gap: 14px;
    min-height: 104px;
}

.info-icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--green-soft);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--green-2);
    font-size: 22px;
    flex-shrink: 0;
}

.info-text span {
    display: block;
    color: var(--text-light);
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 6px;
}

.info-text strong {
    font-size: 14px;
    color: var(--text-dark);
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.details-box {
    background: linear-gradient(180deg, rgba(255,255,255,0.92), rgba(243,250,246,0.88));
    border: 1px solid var(--green-border);
    border-radius: var(--radius-md);
    padding: 18px 18px;
}

.details-item span {
    display: block;
    color: var(--text-light);
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 8px;
}

.details-item strong {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-dark);
    line-height: 1.5;
}

.details-divider {
    height: 1px;
    background: var(--line);
    margin: 18px 0;
}

.amount-box {
    background: var(--green-soft);
    border: 1px solid var(--green-border);
    border-radius: var(--radius-md);
    padding: 16px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 82px;
}

.amount-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

.amount-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    color: var(--green);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
}

.amount-left span {
    font-size: 14px;
    font-weight: 600;
    color: #204029;
}

.amount-value {
    font-size: 22px;
    font-weight: 600;
    color: #1f2622;
    letter-spacing: 0.3px;
}

.invoice-box {
    display: flex;
    gap: 14px;
    align-items: center;
}

.invoice-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: var(--green-soft);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--green-2);
    font-size: 20px;
    flex-shrink: 0;
}

.invoice-text span {
    display: block;
    color: #4e5b53;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 6px;
}

.invoice-text h3 {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.45;
    color: #204029;
    word-break: break-word;
    letter-spacing: 0.2px;
}

.transfer-card {
    margin-top: 8px;
    background: linear-gradient(180deg, rgba(255,255,255,0.94), rgba(245,251,247,0.94));
    border: 1px solid var(--green-border);
    border-radius: var(--radius-md);
    padding: 18px 16px 14px;
}

.bank-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 14px;
    margin-bottom: 10px;
}

.bank-row span {
    color: #303a34;
    font-weight: 400;
}

.bank-row strong {
    color: #1a251f;
    text-align: right;
    font-weight: 500;
}

.btn {
    width: 100%;
    border: none !important;
    border-radius: 12px;
    cursor: pointer;
    font-family: inherit;
    transition: 0.25s ease;
}

.btn:hover {
    transform: translateY(-1px);
    opacity: 0.96;
}

.transfer-btn {
    height: 48px;
    margin-top: 10px;
    background: linear-gradient(90deg, #03572c, #0b6f38);
    color: white !important;
    font-size: 15px;
    font-weight: 600;
}

.expire-note {
    margin-top: 14px;
    background: var(--green-soft);
    border: 1px solid var(--green-border);
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 400;
    color: #49554d;
    text-align: center;
}

.expire-note i {
    color: var(--green);
    margin-right: 6px;
}

.expire-note strong {
    color: var(--green);
    font-weight: 600;
}

.or-pay {
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #587060;
    margin: 22px 0 16px;
    position: relative;
}

.or-pay::before,
.or-pay::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 32%;
    height: 1px;
    background: var(--line);
}

.or-pay::before {
    left: 0;
}

.or-pay::after {
    right: 0;
}

.gateway-section {
    margin-top: 24px;
}

.gateway-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 11px;
}

.gateway-card {
    min-height: 92px;
    background: #ffffff;
    border: 1px solid #e3e5eb;
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 9px;
    transition: 0.25s ease;
    font-family: inherit;
    padding: 12px 10px;
}

.gateway-card:hover {
    border-color: #0e6e3a;
    box-shadow: 0 10px 24px rgba(14, 110, 58, 0.12);
    transform: translateY(-2px);
}

.gateway-card:focus {
    outline: none;
    border-color: #0e6e3a;
    box-shadow: 0 0 0 4px rgba(14, 110, 58, 0.12);
}

.gateway-card:disabled {
    cursor: not-allowed;
    opacity: 0.85;
}

.gateway-card.active {
    border-color: #0e6e3a;
    background: #f4fbf7;
    box-shadow: 0 10px 24px rgba(14, 110, 58, 0.14);
}

.gateway-card.loading {
    border-color: #0e6e3a;
    background: #f4fbf7;
}

.gateway-logo {
    width: 48px;
    height: 48px;
    border: 1px solid #edf0f5;
    border-radius: 14px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.gateway-logo svg {
    width: 34px;
    height: 34px;
    display: block;
}

.gateway-card span {
    font-size: 14px;
    font-weight: 600;
    color: #30323b;
    text-align: center;
}

.print-btn {
    height: 46px;
    margin-top: 14px;
    background: #fff;
    color: #2a312d;
    border: 1px solid var(--line);
    font-size: 15px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.print-btn i {
    color: var(--green);
}

.print-btn:disabled {
    opacity: 0.8;
    cursor: not-allowed;
}

.success-shell {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.success-card {
    width: min(560px, 100%);
    padding: 42px 34px;
    text-align: center;
}

.success-icon-wrap {
    margin-bottom: 18px;
}

.success-image {
    max-width: 100px;
}

.success-card h2 {
    font-size: 28px;
    font-weight: 700;
    color: var(--green-dark);
    margin-bottom: 10px;
}

.success-card p {
    color: var(--text-light);
    margin-bottom: 26px;
}

.action-btn {
    max-width: 260px;
    margin: 0 auto;
}

:deep(button.vue-btn) {
    width: 100%;
    border: none !important;
    border-radius: 12px !important;
    font-family: inherit;
    font-weight: inherit;
    min-height: inherit;
    box-shadow: none;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    text-align: left;
}

:deep(button.vue-btn.print-success-btn) {
    background: #fff !important;
    color: #2a312d !important;
    border: 1px solid var(--line) !important;
}

:deep(button.vue-btn.transfer-btn) {
    background: linear-gradient(90deg, #03572c, #0b6f38) !important;
    color: #fff !important;
    border: none !important;
}

:deep(button.vue-btn .spinner),
:deep(button.vue-btn .check),
:deep(button.vue-btn .cross) {
    justify-self: start;
}

:deep(button.vue-btn > span:last-child),
:deep(button.vue-btn > i:last-child) {
    justify-self: end;
}

.footer-note {
    text-align: center;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 14px;
    padding: 12px 10px;
}

.footer-note p {
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 8px;
}

.footer-note small {
    font-size: 13px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.72);
}

.success-shell {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.success-card {
    width: min(560px, 100%);
    padding: 42px 34px;
    text-align: center;
}

.success-icon-wrap {
    margin-bottom: 18px;
}

.success-image {
    max-width: 100px;
}

.success-card h2 {
    font-size: 28px;
    font-weight: 700;
    color: var(--green-dark);
    margin-bottom: 10px;
}

.success-card p {
    color: var(--text-light);
    margin-bottom: 26px;
}

.action-btn {
    max-width: 260px;
    margin: 0 auto;
}

:deep(button.vue-btn) {
    width: 100%;
    border: none !important;
    border-radius: 12px !important;
    font-family: inherit;
    font-weight: inherit;
    min-height: inherit;
    box-shadow: none;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    text-align: left;
}

:deep(button.vue-btn.btn-remita) {
    background: linear-gradient(90deg, #ff7b1f, #f26b11) !important;
    color: #fff !important;
    border: none !important;
}

:deep(button.vue-btn.btn-monnify) {
    background: linear-gradient(90deg, #0996a7, #087c8b) !important;
    color: #fff !important;
    border: none !important;
}

:deep(button.vue-btn.btn-print),
:deep(button.vue-btn.print-success-btn) {
    background: #fff !important;
    color: #2a312d !important;
    border: 1px solid var(--line) !important;
}

:deep(button.vue-btn.transfer-btn) {
    background: linear-gradient(90deg, #03572c, #0b6f38) !important;
    color: #fff !important;
    border: none !important;
}

:deep(button.vue-btn .spinner),
:deep(button.vue-btn .check),
:deep(button.vue-btn .cross) {
    justify-self: start;
}

:deep(button.vue-btn > span:last-child),
:deep(button.vue-btn > i:last-child) {
    justify-self: end;
}

@media (max-width: 1100px) {
    .content-grid {
        grid-template-columns: 1fr;
    }

    .secure-box {
        display: none;
    }
}

@media (max-width: 768px) {
    .custom-payment-wrapper {
        padding: 16px;
    }

    .custom-payment-wrapper::before,
    .custom-payment-wrapper::after {
        display: none;
    }

    .top-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .brand-area {
        align-items: flex-start;
    }

    .logo-circle {
        width: 72px;
        height: 72px;
    }

    .brand-text h1 {
        font-size: 18px;
    }

    .main-card,
    .sidebar-card,
    .success-card {
        padding: 20px;
    }

    .section-intro {
        align-items: flex-start;
    }

    .intro-icon {
        width: 58px;
        height: 58px;
        font-size: 22px;
    }

    .section-intro h2 {
        font-size: 21px;
    }

    .info-grid {
        grid-template-columns: 1fr;
    }

    .amount-box {
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
    }

    .amount-value {
        font-size: 24px;
    }

    .bank-row {
        flex-direction: column;
        gap: 4px;
    }

    .bank-row strong {
        text-align: left;
    }
}

@media (max-width: 480px) {
    .brand-area {
        gap: 12px;
    }

    .brand-text h1 {
        font-size: 16px;
    }

    .brand-text p {
        font-size: 12px;
    }

    .main-card,
    .sidebar-card,
    .success-card {
        border-radius: 18px;
    }

    .info-card {
        padding: 18px 16px;
    }

    .gateway-grid {
        grid-template-columns: 1fr;
    }

    .gateway-card {
        min-height: 86px;
        flex-direction: row;
        justify-content: flex-start;
        padding: 0 18px;
    }

}
</style>
  
